import 'bootstrap';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import $ from 'jquery';
window.$ = window.jQuery = $;
import { dm_hero } from './hero';
import { dm_parallax } from './parallax';

gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {
    "use strict";

    /* NAV OPEN ON MOUSEOVER */
    const $dropdown = $(".dropdown"), $header = $('header'), $nav = $('header .navbar');
    let $admin_bar = $('#wpadminbar');
    const $mobile_breakpoint = '991px';
    let $header_height = $('header').outerHeight(true);

    function isMobileDevice() {
        if ($(window).width() <= 1080) {
            return true;
        }
        return /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|Mobile|BlackBerry/i.test(navigator.userAgent);
    }
    

    $(window).on("resize", function () {
        // NAV DROPDOWNS
        if (this.matchMedia("(min-width: " + $mobile_breakpoint + ")").matches) {
            $("header .navbar .navbar-nav > li.dropdown").on({
                mouseenter: function () {
                    const $this = $(this);
                    $this.addClass("show");
                    $this.find(".dropdown-toggle").addClass("show").attr("aria-expanded", "true");
                    $this.find(".dropdown-menu").addClass("show");
                },
                mouseleave: function () {
                    const $this = $(this);
                    $this.removeClass("show");
                    $this.find(".dropdown-toggle").removeClass("show").attr("aria-expanded", "false");
                    $this.find(".dropdown-menu").removeClass("show");
                }
            });
        } else {
            $dropdown.off("mouseenter mouseleave");
        }

        // NAV DROPDOWN CLICKS
        if (!isMobileDevice()) {
            $('header .navbar .navbar-nav > li.dropdown a').on('click', function (e) {
                console.log('>> CLICK: header .navbar .navbar-nav > li.dropdown a')

                e.preventDefault();
                e.stopPropagation();
                window.location.href = $(this).attr('href');
            });
        } else {
            $('body').on('click', 'header .navbar .navbar-nav > li.dropdown > a', function (e) {
                e.preventDefault();
                e.stopPropagation();
                
                if ($(this).hasClass('open')) {
                    window.location.href = $(this).attr('href');
                    $(this).parent().find('.dropdown-menu').removeClass('show');
                } else {
                    $(this).parent().find('.dropdown-menu').addClass('show');
                    // $('header .navbar .navbar-nav > li.dropdown > a').removeClass('open');
                }
                $(this).toggleClass('open');
            });
        }

        // NAV / BODY 
        $('body').css('padding-top', $header_height);
        if ($admin_bar.length) {
            $header.css('top', $admin_bar.outerHeight());
        }

        // NAV MINIMISE
        if (this.matchMedia("(min-width: " + $mobile_breakpoint + ")").matches) {

            $(window).on('scroll', function () {
                let scroll_top = $(window).scrollTop();

                if (scroll_top > $header_height) {
                    $('header').addClass('minimal');
                    $('.fullwidth-submenu').addClass('minimal');
                } else {
                    $('header').removeClass('minimal');
                    $('.fullwidth-submenu').removeClass('minimal');
                }
            });

        }

    });

    // LOCATIONS MENU
    $('header nav li.locations .sub-menu li.region > a').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('header nav li.locations .sub-menu .sub-menu').css('display', 'none');
        $(this).parent().find('.sub-menu').css('display', 'block');
    });

    //HAMBURGER ACTIVE
    $('header .hamburger').on('click', function (e) {
        $(this).toggleClass('is-active');
        $('body').toggleClass('menu-open');
        if ($('header .navbar .navbar-collapse').hasClass('show')) {
            $('header .navbar .navbar-collapse').removeClass('show')
        }
    });

    $(window).trigger('resize');

    $(window).on('scroll', function () {
        if ($(window).scrollTop() === 0) {
            $(window).delay(750).trigger('resize'); // could be written better
        }
    });

    $.fn.dm_create_slug = function (string) {
        return string
            .toLowerCase()
            .replace(/[^a-zA-Z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .trim();
    }

    dm_hero();
    dm_parallax();
});